import { appLinks, withLocale } from "../config/appLinks";
import { useTranslation } from "../i18n/LocaleContext";
import { ExternalLink } from "./SupportLink";

export default function AppFooter() {
  const { t, locale } = useTranslation();

  return (
    <footer className="app-footer">
      <ExternalLink href={withLocale(appLinks.privacy, locale)} label={t("footer.privacy")} />
      <ExternalLink href={withLocale(appLinks.terms, locale)} label={t("footer.terms")} />
      {/* Sem withLocale: a página de suporte ignora o parâmetro. */}
      <ExternalLink href={appLinks.support} label={t("footer.support")} />
    </footer>
  );
}
